(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~loading~table"],{

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "SpinProps", function() { return /* reexport */ loading_SpinProps; });

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(67);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/loading/loading.jsx


var _excluded = ["size", "prefixCls", "tip", "wrapperClassName"];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var SpinSize = vue_types["a" /* default */].oneOf(['small', 'default', 'large']);
var loading_SpinProps = function SpinProps() {
  return {
    prefixCls: vue_types["a" /* default */].string,
    spinning: vue_types["a" /* default */].bool,
    size: SpinSize,
    wrapperClassName: vue_types["a" /* default */].string,
    tip: vue_types["a" /* default */].string,
    delay: vue_types["a" /* default */].number,
    indicator: vue_types["a" /* default */].any
  };
}; // Render indicator

var defaultIndicator;

function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}

function setDefaultIndicator(Content) {
  defaultIndicator = typeof Content.indicator === 'function' ? Content.indicator : function (h) {
    return h(Content.indicator);
  };
}
/* harmony default export */ var loading = ({
  name: 'MegLoading',
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])(loading_SpinProps(), {
    size: 'default',
    spinning: true,
    wrapperClassName: ''
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var spinning = this.spinning,
        delay = this.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    this.originalUpdateSpinning = this.updateSpinning;
    this.debouncifyUpdateSpinning(this.$props);
    return {
      sSpinning: spinning && !shouldBeDelayed
    };
  },
  mounted: function mounted() {
    this.updateSpinning();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.debouncifyUpdateSpinning();

      _this.updateSpinning();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelExistingSpin();
  },
  methods: {
    debouncifyUpdateSpinning: function debouncifyUpdateSpinning(props) {
      var _ref = props || this.$props,
          delay = _ref.delay;

      if (delay) {
        this.cancelExistingSpin();
        this.updateSpinning = debounce_default()(this.originalUpdateSpinning, delay);
      }
    },
    updateSpinning: function updateSpinning() {
      var spinning = this.spinning,
          sSpinning = this.sSpinning;

      if (sSpinning !== spinning) {
        this.setState({
          sSpinning: spinning
        });
      }
    },
    cancelExistingSpin: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;

      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    },
    getChildren: function getChildren() {
      if (this.$slots && this.$slots.default) {
        return Object(props_util["filterEmpty"])(this.$slots.default);
      }

      return null;
    },
    renderIndicator: function renderIndicator(h, prefixCls) {
      // const h = this.$createElement
      var dotClassName = "".concat(prefixCls, "-dot");
      var indicator = Object(props_util["getComponentFromProp"])(this, 'indicator'); // should not be render default indicator when indicator value is null

      if (indicator === null) {
        return null;
      }

      if (Array.isArray(indicator)) {
        indicator = Object(props_util["filterEmpty"])(indicator);
        indicator = indicator.length === 1 ? indicator[0] : indicator;
      }

      if (Object(props_util["isValidElement"])(indicator)) {
        return Object(vnode["a" /* cloneElement */])(indicator, {
          class: dotClassName
        });
      }

      if (defaultIndicator && Object(props_util["isValidElement"])(defaultIndicator(h))) {
        return Object(vnode["a" /* cloneElement */])(defaultIndicator(h), {
          class: dotClassName
        });
      }

      return h("meg-icon", {
        "class": "".concat(dotClassName, " ").concat(prefixCls, "-dot-spin"),
        attrs: {
          name: 'megui-loading'
        }
      }); // return (
      //   <span class={`${dotClassName} ${prefixCls}-dot-spin`}>
      //     <i class={`${prefixCls}-dot-item`} />
      //     <i class={`${prefixCls}-dot-item`} />
      //     <i class={`${prefixCls}-dot-item`} />
      //     <i class={`${prefixCls}-dot-item`} />
      //   </span>
      // );
    }
  },
  render: function render(h) {
    var _spinClassName;

    var _this$$props = this.$props,
        size = _this$$props.size,
        customizePrefixCls = _this$$props.prefixCls,
        tip = _this$$props.tip,
        wrapperClassName = _this$$props.wrapperClassName,
        restProps = _objectWithoutProperties(_this$$props, _excluded);

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('spin', customizePrefixCls);
    var sSpinning = this.sSpinning;
    var spinClassName = (_spinClassName = {}, _defineProperty(_spinClassName, prefixCls, true), _defineProperty(_spinClassName, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_spinClassName, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_spinClassName, "".concat(prefixCls, "-spinning"), sSpinning), _defineProperty(_spinClassName, "".concat(prefixCls, "-show-text"), !!tip), _spinClassName);
    var spinElement = h("div", babel_helper_vue_jsx_merge_props_default()([restProps, {
      "class": spinClassName
    }]), [this.renderIndicator(h, prefixCls), tip ? h("div", {
      "class": "".concat(prefixCls, "-text")
    }, [tip]) : null]);
    var children = this.getChildren();

    if (children) {
      var _containerClassName;

      var containerClassName = (_containerClassName = {}, _defineProperty(_containerClassName, "".concat(prefixCls, "-container"), true), _defineProperty(_containerClassName, "".concat(prefixCls, "-blur"), sSpinning), _containerClassName);
      return h("div", babel_helper_vue_jsx_merge_props_default()([{
        on: Object(props_util["getListeners"])(this)
      }, {
        "class": ["".concat(prefixCls, "-nested-loading"), wrapperClassName]
      }]), [sSpinning && h("div", {
        key: "loading"
      }, [spinElement]), h("div", {
        "class": containerClassName,
        key: "container"
      }, [children])]);
    }

    return spinElement;
  }
});
// EXTERNAL MODULE: ./src/base/base/index.js
var base = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/loading/index.jsx



loading.setDefaultIndicator = setDefaultIndicator; // import './style/index.scss';

/* istanbul ignore next */

loading.install = function (Vue) {
  Vue.use(base["a" /* default */]);
  Vue.component(loading.name, loading);
};

/* harmony default export */ var components_loading = __webpack_exports__["default"] = (loading);

/***/ })

}]);